var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: { name: "fade", appear: "" },
      on: {
        "before-enter": _vm.beforeEnter,
        enter: _vm.enter,
        leave: _vm.leave,
      },
    },
    [
      _vm.isVisible
        ? _c(
            "div",
            {
              staticClass: "full-categories-menu bg-white",
              on: { mouseenter: _vm.enterMenu, mouseleave: _vm.leaveMenu },
            },
            [
              _c("div", { staticClass: "category-content" }, [
                _c(
                  "div",
                  _vm._l(_vm.menuList, function (item, idx) {
                    return _c(
                      "div",
                      { staticClass: "menu-list" },
                      [
                        _c("router-link", { attrs: { to: item.href || "/" } }, [
                          _vm._v(_vm._s(item.name)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(item.children, function (item2, idx2) {
                            return _c(
                              "li",
                              {
                                staticClass: "depth-2",
                                class: [
                                  item2.class || "",
                                  { "no-arrow": !item2 || !item2.children },
                                ],
                                on: {
                                  mouseover: function ($event) {
                                    _vm.hoverIdx = [idx, idx2]
                                  },
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: item2.href
                                        ? `/product/${item2.href}`
                                        : item2.children?.[0]?.href
                                        ? `/product/${item2.children[0].href}`
                                        : "#",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          item2.name.split("] ")[1] ||
                                            item2.name
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                item2 && item2.children
                                  ? _c(
                                      "ul",
                                      { staticClass: "last-depth-ul" },
                                      _vm._l(item2.children, function (item3) {
                                        return _c(
                                          "li",
                                          { class: item3.class },
                                          [
                                            _c(
                                              "a",
                                              {
                                                class: !item3.href
                                                  ? "cursor-default"
                                                  : "",
                                                attrs: {
                                                  href: item3.href
                                                    ? `/product/${item3.href}`
                                                    : "#",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item3.name.split(
                                                        "] "
                                                      )[1] || item3.name
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("i", { staticClass: "n-icon" }, [
                                              _vm._v("N"),
                                            ]),
                                            _vm._v(" "),
                                            _c("i", { staticClass: "h-icon" }, [
                                              _vm._v("H"),
                                            ]),
                                            _vm._v(" "),
                                            _c("i", { staticClass: "b-icon" }, [
                                              _vm._v("B"),
                                            ]),
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "right-info" }, [
                  _c("div", { staticClass: "top-field" }, [
                    _c("img", {
                      attrs: {
                        src: `/assets/img/dummyImgs/dummy${_vm.hoverIdx[0]}/0.png`,
                      },
                    }),
                    _vm._v(" "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.dummyData[_vm.hoverIdx[0]]?.[_vm.hoverIdx[1]]
                            .title
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      _vm._l(
                        _vm.dummyData[_vm.hoverIdx[0]]?.[
                          _vm.hoverIdx[1]
                        ].tags.split(","),
                        function (tag) {
                          return _c("li", [_vm._v(_vm._s(tag.trim()))])
                        }
                      ),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottom-field" }, [
                    _c("p", [
                      _vm._v(
                        "\n                        환경친화적 인쇄를 지향하는\n                        "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                        인쇄의 넘버원,\n                        "
                      ),
                      _c("strong", [_vm._v("프리원!")]),
                    ]),
                    _vm._v(" "),
                    _c("img", { attrs: { src: "/assets/img/soyinkmark.svg" } }),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }